function IconTalkTimeLowFace() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 24C0 10.7451 10.7451 0 24 0C37.2549 0 48 10.7451 48 24C48 37.2549 37.2549 48 24 48C10.7451 48 0 37.2549 0 24ZM15.3337 33.3333C14.2291 33.3333 13.3337 34.2288 13.3337 35.3333C13.3337 36.4379 14.2291 37.3333 15.3337 37.3333H32.667C33.7716 37.3333 34.667 36.4379 34.667 35.3333C34.667 34.2288 33.7716 33.3333 32.667 33.3333H15.3337ZM16.4311 15.6377C18.7986 15.6377 20.7186 17.556 20.7186 19.9234C20.7186 22.2908 18.7986 24.2091 16.4311 24.2091C14.0654 24.2091 12.1471 22.2908 12.1471 19.9234C12.1471 17.556 14.0654 15.6377 16.4311 15.6377ZM36.1469 19.9234C36.1469 17.556 34.2269 15.6377 31.8595 15.6377C29.4938 15.6377 27.5755 17.556 27.5755 19.9234C27.5755 22.2908 29.4938 24.2091 31.8595 24.2091C34.2269 24.2091 36.1469 22.2908 36.1469 19.9234Z"
        fill="white"
      />
    </svg>
  );
}

export { IconTalkTimeLowFace };
